import React from "react";
// import PostSlider from "@/components/pages/blog/post-slider";
import ReadMorePosts from "@/components/pages/blog/read-more-blogs";
import { getUrqlClient } from "@/lib/urql-client";
import {
  QUERY_ALL_BLOGS_SELECTIVE,
  QUERY_ALL_BLOGS_TOTAL,
  QUERY_BLOG_CATEGORIES,
} from "@/framework/queries/blogs";
import { sanitize } from "@/framework/utils/sanitize";
import BlogLandingBanner from "@/components/pages/blog/blog-landing-banner";
import BlogListing from "@/components/pages/blog/blog-listing";
import Seo from "@/utils/seo";
export default function BlogLanding({ blogCategories, total, featured }) {
  const seo = {
    slug: "blogs",
    metaTitle: "Chalk Studio Blogs: Interior Design Inspiration & Insights",
    metaDescription:
      "Discover Chalk Studio blogs featuring interior design trends, home styling ideas, and expert tips across spaces like kitchens, living rooms, and more.",
  };
  return (
    <>
      <Seo seo={seo} />
      <BlogLandingBanner featured={featured} />
      <BlogListing blogCategories={blogCategories} totalBlogs={total} />
      <ReadMorePosts />
    </>
  );
}

export async function getStaticProps({ params }) {
  const client = await getUrqlClient();
  let blogCategories = null;
  let total = null;
  let featured = null;
  try {
    total = await client.query(QUERY_ALL_BLOGS_TOTAL, {
      requestPolicy: "network-only",
    });
    featured = await client.query(
      QUERY_ALL_BLOGS_SELECTIVE,
      {
        start: 0,
        limit: 1,
        sortBy: ["id:desc"],
        filter: {},
      },
      {
        requestPolicy: "network-only",
      }
    );

    blogCategories = await client.query(
      QUERY_BLOG_CATEGORIES,
      {
        start: 0,
        limit: 20,
      },
      { requestPolicy: "network-only" }
    );
  } catch (err) {
    console.log(err);
  }

  return {
   /* props: {
      total: total?.data?.blogs?.meta?.pagination?.total?? 0,
      blogCategories:
        blogCategories?.data?.blogCategories?.data?.map((row) =>
          sanitize(row)
        ) ?? {},
      featured: featured?.data?.blogs?.data.map((row) => sanitize(row)) || [],
    },TODO SSS*/
      props: {
          total: total?.data?.blogs?.meta?.pagination?.total ?? 0,
          blogCategories: Array.isArray(blogCategories?.data?.blogCategories?.data)
              ? blogCategories.data.blogCategories.data.map((row) => sanitize(row))
              : [],
          featured: Array.isArray(featured?.data?.blogs?.data)
              ? featured.data.blogs.data.map((row) => sanitize(row))
              : [],
      },
    revalidate: 1, // In seconds
  };
}
